import { render, staticRenderFns } from "./Respond.vue?vue&type=template&id=08df3128&"
import script from "./Respond.vue?vue&type=script&lang=js&"
export * from "./Respond.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports